import {AcaoAuditoria} from "./trilha-auditoria/acao-auditoria";

export class Auditoria {
  idAuditoria: any;
  timestamp: string;
  usuario: string;
  autorizador: string;
  tipoCadastro: string;
  descricao: string;
  acao: AcaoAuditoria;
  identificador: string;
}
